import React, { Component } from "react";
import request, { tracesDirectUrl, tracesToken } from "../../lib/requester";
import _ from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import Autocomplete from "../../component/autocomplete";
import { Modal, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { Loader } from "react-overlay-loader";

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lovSupplierSite: [],
      lovSupplier: [],
      supplier: "",
      supplierId: 0,
      supplierSite: 0,
      orgId: "",
      skbNumber: "",
      orgInitial: "",
      bankName: "",
      accOwner: "",
      paymentMethod: "",
      norek: "",
      npwp: "",
      skb: "N",
      taxNo: "",
      taxDate: new Date(),
      fileSKB: { filename: "", path: "" },
      fileLain: { filename: "", path: "" },
      fileTambahan: { filename: "", path: "" },
      fileBupot: { filename: "", path: "" },
      fileRequired: { filename: "", path: "" },
      principalName: "",
      description: "",
      branchId: "",
      refNumber: "",
      programType: "",
      customerName: "",
      customerId: "",
      potongTagihan: "",
      pphRate: 1,
      pphType: "",
      dpp: 0,
      ppn: 0,
      pph: 0,
      totalAmount: 0,
      docs: [],
      fileContainer: [],
      error: [],
      listInvoice: [],
      lovPPH: [],
      success: "",
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
      submitteddate: "",
      skpnumber: "",
      programNumber: "",
      budgetType: "",
      program_budget: 0,
      assign_budget: 0,
      sales_target: 0,
      skpnumber: "",
      claimnumber: "",
      kwitansi: "",
      header_npwp: "",
      header_npwp_name: "",
      header_npwp_address: "",
      docsContainer: [],
      productList: [],
      ebupot_filename: "",
      ebupot_path: "",

      // 
      newFileName: ''
    };
  }

  componentDidMount = () => {
    this.getDetailProgram();
    this.getPPhType();
  };

  getPPhType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  renderLovPPh = () => {
    return (
      <select
        disabled
        className="form-control"
        name="pphType"
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  getNpwp = () => {
    let url = "/api/orafin/v1/general/npwp-customer";
    let param = {
      customerid: this.state.customerId,
      branchId: this.state.branchId,
    };
    this.setState({ loading: true });
    request.postOracle(url, param, {
      success: function (response) {
        let { data } = response.data;
        this.setState({
          npwp: data.npwp,
          header_npwp: data.npwp,
          header_npwp_name: data.name,
          header_npwp_address: data.address,
          loading: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/claim/detail-summary";
    let { id } = this.props.match.params;
    let param = {
      claim_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let {
          header,
          claim,
          attachment,
          invoice,
          document,
          product,
          npwp
        } = response.data.data;
        if (claim.doc_mandatory_filename) {
          attachment.push({
            document_name: "",
            path: claim.doc_mandatory_path || "",
            filename: claim.doc_mandatory_filename || "",
            key: claim.doc_mandatory_file_key ? claim.doc_mandatory_file_key : claim.bupot_file_key,
            claim_id: claim.claim_id,
            doc: 'mandatory',
            claim_number: header.claim_number
          });
        }
        if (claim.doc_tambahan_filename) {
          attachment.push({
            document_name: "Additional Document",
            path: claim.doc_tambahan_path || "",
            filename: claim.doc_tambahan_filename || "",
            key: claim.bupot_file_key ? claim.bupot_file_key : claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
            doc: 'aditional'
          });
          document.push({
            document_name: "Additional Document",
            path: claim.doc_tambahan_path || "",
            filename: claim.doc_tambahan_filename || "",
            key: claim.bupot_file_key ? claim.bupot_file_key : claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
          });
        }
        if (claim.doc_bupot_filename) {
          attachment.push({
            document_name: "Additional Document",
            path: claim.doc_bupot_path || "",
            filename: claim.doc_bupot_filename || "",
            key: claim.bupot_file_key ? claim.bupot_file_key : claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
            doc: 'bupot'
          });
          document.push({
            document_name: "Additional Document",
            path: claim.doc_bupot_path || "",
            filename: claim.doc_bupot_filename || "",
            key: claim.bupot_file_key ? claim.bupot_file_key : claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
            doc: 'bupot'
          });
        }
        let newDocs = document;
        let newAttach = attachment;

        this.setState({
          newFileName: claim.doc_bupot_filename,
          productList: product,
          kwitansi: header.kwitansi,
          claimnumber: header.claim_number,
          programNumber: header.program_number,
          budgetType: header.budget_type,
          sisabudget: header.sisa_budget,
          program_budget: header.program_budget,
          assign_budget: header.assign_budget,
          sales_target: header.sales_target,
          supplier: claim.aam_vendor_name,
          supplierId: claim.aam_vendor_id,
          supplierSite: claim.aam_vendor_site_id,
          skbNumber: claim.skb_number,
          loading: false,
          bankName: claim.bank,
          accOwner: claim.bank_acc_owner,
          principalName: header.org_name,
          branchId: header.branch_id,
          skpnumber: header.skp_number,
          refNumber: header.ref_number,
          programType: header.program_name,
          description: header.description,
          customerName: header.customer_name || "",
          customerId: header.customer_id || "",
          dpp: this.thousandSeparator(claim.dpp || 0),
          ppn: this.thousandSeparator(claim.ppn || 0),
          pphRate: claim.pph_rate,
          pphType: claim.pph_type,
          pph: claim.pph ? this.thousandSeparator(claim.pph) : 0,
          potongTagihan: claim.potong_tagihan,
          docs: newAttach,
          docsContainer: newDocs,
          listInvoice: invoice,
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
          claimExpDate: moment(header.claim_exp_date).format("DD-MMM-YYYY"),
          startDate: moment(header.start_date).format("DD-MMM-YYYY"),
          endDate: moment(header.end_date).format("DD-MMM-YYYY"),
          paymentMethod: claim.payment_method,
          npwp: claim.npwp,
          norek: claim.no_rekening,
          skb: claim.skb,
          taxNo: claim.tax_no,
          taxDate: moment(claim.tax_date).format("DD-MMM-YYYY"),
          fileSKB: {
            filename: claim.doc_skb_filename,
            path: claim.doc_skb_path,
          },
          fileLain: {
            filename: claim.doc_lain_filename,
            path: claim.doc_lain_path,
          },
          fileTambahan: {
            filename: claim.doc_tambahan_filename,
            path: claim.doc_tambahan_path,
          },
          fileRequired: {
            filename: claim.doc_mandatory_filename,
            path: claim.doc_mandatory_path,
            key: claim.bupot_file_key,
            claim_id: claim.claim_id,
          },
          fileBupot: {
            filename: claim.doc_bupot_filename,
            path: claim.doc_bupot_path,
            key: claim.bupot_file_key,
            claim_id: claim.claim_id,
            doc: 'bupot'
          },
          ebupot_filename: claim.doc_bupot_filename,
          ebupot_path: claim.doc_bupot_path,
          header_npwp: npwp ? npwp.NPWP_NUMBER : '',
          header_npwp_name: npwp ? npwp.NPWP_NAME : '',
          header_npwp_address: npwp ? npwp.NPWP_ADDRESS : '',
        });
        this.getSupplierSite(claim.aam_vendor_id);
        // this.getNpwp();
        let app = this;
        window.setTimeout(() => {
          app.calculateAmount();
          console.log(app.state);
        }, 200);
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  thousandSeparator = (value) => {
    value = value.toString();
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    value = value.toString();
    return value.replace(/,/g, "");
  };

  calculateAmount = () => {
    let { dpp, ppn, pph, totalAmount } = this.state;
    totalAmount =
      (parseInt(this.removeSeparator(dpp)) || 0) +
      (parseInt(this.removeSeparator(ppn)) || 0) -
      (parseInt(this.removeSeparator(pph)) || 0);
    let app = this;
    window.setTimeout(() => {
      totalAmount = Math.round(totalAmount); // ilham, menambahkan round
      app.setState({
        totalAmount: this.thousandSeparator(totalAmount),
        ppn: this.thousandSeparator(ppn),
      });
    }, 500);
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "pph" || name === "ppn" || name === "dpp") {
      value = this.thousandSeparator(value);
    }

    this.setState({ [name]: value });
    if (name === "pph" || name === "ppn" || name === "dpp") {
      let app = this;
      window.setTimeout(() => {
        app.calculateAmount();
        app.forceUpdate();
      }, 100);
    }
  };

  renderDocument = () => {
    return this.state.docsContainer.map((item, index) => (
      <div className="row">
        <div className="col-md-12">
          <i className="fa fa-check text-success" />
          &nbsp;{item.document_name}
        </div>
      </div>
    ));
  };

  renderProduct = () => {
    // console.log(this.state.productList)
    return this.state.productList.map((item, index) => (
      <div className="row mb-2" key={index}>
        <div className="col-sm-4">
          <input
            disabled
            type="text"
            className="form-control"
            name="productname"
            value={item.item_description}
          />
        </div>
        <div className="col-sm-2">
          <input
            disabled
            type="text"
            className="form-control"
            name="itemReff"
            value={item.item_reff}
          />
        </div>
        <div className="col-sm-2">
          <input
            disabled
            type="text"
            className="form-control"
            name="itemBudget"
            // value={item.item_budget}
            value={
              item.item_budget
                ? item.item_budget.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : 0
            }
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            disabled
            className="form-control"
            name="itemActual"
            currentIndex={index}
            value={
              item.actual
                ? item.actual.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : 0
            }
            placeholder="actual"
          />
        </div>
      </div>
    ));
  };

  renderLink = () => {
    return this.state.docs.map((item, index) => (
      <div className="col-md-12">
        <i className="fa fa-file-pdf text-danger" />
        &nbsp;{" "}
        <a style={{ color: "blue" }} onClick={() => this.downloadAttachment(item, 'preview')}>
          {item.doc === "mandatory" ? item.claim_number.replace(/[/]/g, '') : item.filename}
        </a>
        <Button type="primary" icon={<DownloadOutlined />} className="ml-3" onClick={() => this.downloadAttachment(item)} />
      </div>
    ));
  };

  downloadAttachment = (data, preview) => {
    this.setState({ loading: true });
    let url = data.doc === 'bupot' ?
      `/api/traces/v1/tracking-email/download-surat-refund?bupot_file_key=${data.key}&bupot_filename=${data.filename}` :
      data.doc === 'mandatory' ?
        `/api/traces/v1/tracking-email/download-surat-refund?mandatory_filename=${data.filename}&mandatory_file_key=${data.key}` :
        `/api/traces/v1/tracking-email/download-surat-refund?additional_FileName=${data.filename}&mandatory_file_key=${data.key}`

    request.getTraces(url, {
      success: function (response) {
        if (response.data.statusCode === 400) {
          window.open(data.path, "_blank");
          this.setState({ loading: false });
        } else {
          axios({
            url: response.config.url,
            method: 'GET',
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${tracesToken()}`,
            },
          }).then((response) => {
            if (preview && preview === 'preview') {
              const objectUrl = URL.createObjectURL(response.data)
              const pdfWindow = window.open();
              pdfWindow.location.href = objectUrl;
              // window.open(response.config.url, "_blank");
              this.setState({ loading: false });
            } else {
              const href = URL.createObjectURL(response.data);
              const link = document.createElement('a');
              link.href = href;
              link.setAttribute('download', data.doc === "bupot" ? `CLAIM_${data.claim_id}.pdf` : data.doc === "mandatory" ? `${data.claim_number.replace(/[/]/g, '')}.pdf` : `${data.filename}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              this.setState({ loading: false });
            }
          })
            .catch(error => {
              window.open(data.path, "_blank");
              this.setState({ loading: false });
            })
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  }

  handleUpload = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let { programDocId, index } = e.target.dataset;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobody("/api/arman/v1/program/upload-file", data, {
      success: function (response) {
        let { data } = response.data;
        let container = this.state.fileContainer;
        data.program_doc_id = programDocId;
        data.index = index;
        container.push(data);
        this.setState({ fileContainer: container, loading: false });
        this.forceUpdate();
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      },
    });
  };

  renderUploadedFile = (index) => {
    let { fileContainer } = this.state;
    let find = _.find(fileContainer, function (o) {
      return parseInt(o.index) === parseInt(index);
    });
    if (find) {
      return (
        <span>
          <Link to={{ pathname: find.path }} target="_blank">
            {find.filename}{" "}
          </Link>
          &nbsp;
          <button
            type="button"
            className="btn btn-danger"
            data-index={index}
            onClick={() => {
              this.removeFile(index);
            }}
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </span>
      );
    }
  };

  removeFile = (index) => {
    let indexing = _.findIndex(this.state.fileContainer, function (o) {
      return parseInt(o.index) === parseInt(index);
    });
    if (indexing >= 0) {
      let container = this.state.fileContainer;
      container.splice(indexing, 1);
      this.setState(container);
    }
  };

  validateForm = () => {
    let {
      potongTagihan,
      pphRate,
      pphType,
      dpp,
      ppn,
      fileContainer,
      docs,
    } = this.state;
    let error = [];
    if (potongTagihan === "" || potongTagihan.length === 0) {
      error.push("Potong tagihan belum dipilih");
    }
    if (pphRate === 0 || pphRate.length === 0) {
      error.push("PPh Rate belum diinput");
    }
    if (pphType === "") {
      error.push("PPh Type belum dipilih");
    }
    if (parseInt(dpp) === 0 || dpp.length === 0) {
      error.push("DPP belum diinput");
    }
    if (parseInt(ppn) === 0 || ppn.length === 0) {
      error.push("PPn belum diinput");
    }
    if (fileContainer.length < docs.length) {
      error.push("Lampiran dokumen belum lengkap");
    }

    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    } else {
      return true;
    }
  };
  handleSubmit = () => {
    if (this.validateForm()) {
      let url = "/api/v1/program/claim-submit";
      let {
        potongTagihan,
        pphRate,
        pphType,
        dpp,
        pph,
        ppn,
        totalAmount,
        fileContainer,
      } = this.state;
      let { id } = this.props.match.params;
      let param = {
        program_customer_id: id,
        potongTagihan: potongTagihan,
        rate: pphRate,
        pphType: pphType,
        dpp: this.removeSeparator(dpp),
        ppn: this.removeSeparator(ppn),
        pph: this.removeSeparator(pph),
        totalAmount: this.removeSeparator(totalAmount),
        fileContainer: fileContainer,
        userId: this.state.user.user_id,
      };
      this.setState({ loading: true });
      request.postInfostep(url, param, {
        success: function (response) {
          this.setState({
            loading: false,
            success: "Claim submitted successfully",
          });
          window.scrollTo(0, 0);
          let app = this;
          window.setTimeout(() => {
            app.props.history.push("/admin/claim/summary-assignment");
          }, 2000);
        }.bind(this),
        error: function (e) {
          window.scrollTo(0, 0);
          this.setState({
            loading: false,
            error: ["Failed to submit, please try again"],
          });
        }.bind(this),
      });
    }
  };

  renderTableInvoice = () => {
    if (this.state.paymentMethod === "INV") {
      return (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Invoice Amount</th>
              <th>Invoice Date</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listInvoice.map((item, index) => (
              <tr key="index">
                <td>{item.invoice_number}</td>
                <td>{item.invoice_amount}</td>
                <td>
                  {moment(new Date(item.invoice_date)).format("DD-MMM-YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
  };

  onSelectSupplier = (item, index) => {
    this.setState({ supplier: item.text, supplierId: item.value });
    this.getSupplierSite(item.value);
  };

  getSupplierSite = (id) => {
    if (!id || id.length === 0) {
      return false;
    }
    let url = "/api/orafin/v1/claim/list-supplier-site";
    let param = { supplier_id: id };
    this.setState({ loading: true });
    request.postOracle(url, param, {
      success: function (response) {
        let { data } = response.data;
        let lovSupplierSite = [];
        data.forEach((item, index) => {
          lovSupplierSite.push({
            SUPPLIER_SITE_CODE: item.VENDOR_SITE_CODE,
            SUPPLIER_SITE_ID: item.VENDOR_SITE_ID,
          });
        });
        this.setState({ lovSupplierSite: lovSupplierSite, loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  onChangeAutocomplete = (q) => {
    let param = {
      supplier_name: q,
    };
    return new Promise((resolve, reject) => {
      request.postOracle("/api/orafin/v1/claim/list-supplier", param, {
        success: function (response) {
          let { data } = response.data;
          let lovSupplier = [];
          data.forEach((item, index) => {
            // [0] supplier name [1] supplier id
            lovSupplier.push({ text: item.VENDOR_NAME, value: item.VENDOR_ID });
          });
          resolve(lovSupplier);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  renderNorek = () => {
    if (this.state.paymentMethod === "TRF") {
      // if (this.state.orgInitial === 'AAM') {
      if (1 === 1) {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Supplier
              </label>
              <div className="col-sm-9">
                <Autocomplete
                  onchange={this.onChangeAutocomplete.bind(this)}
                  isDisabled={true}
                  currentvalue={this.state.supplier}
                  currentIndex={0}
                  principalCode={this.state.user.orgInitial}
                  onselect={this.onSelectSupplier.bind(this)}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Supplier Site
              </label>
              <div className="col-sm-9">
                <select
                  disabled
                  className="form-control"
                  value={this.state.supplierSite}
                  name="supplierSite"
                  onChange={this.handleChangeInput.bind(this)}
                >
                  <option value="">- Select Supplier Site -</option>
                  {this.state.lovSupplierSite.map((item, index) => (
                    <option value={item.SUPPLIER_SITE_ID}>
                      {item.SUPPLIER_SITE_CODE}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Account No
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  disabled
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="norek"
                  placeholder="No Rekening"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.norek}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Bank Name
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  disabled
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="bankName"
                  placeholder="Bank Name"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.bankName}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Account Owner
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  disabled
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="accOwner"
                  placeholder="Account Owner"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.accOwner}
                />
              </div>
            </div>
          </div>
        );
      }
    }
  };

  renderTax = () => {
    let { ppn } = this.state;
    if (ppn === "0" || ppn.length === 0) {
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Tax No
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="taxNo"
                placeholder="Tax No"
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.taxNo}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Tax Date
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                className="form-control"
                value={this.state.taxDate}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  handleRedirect = (e) => {
    e.preventDefault()
    const url = request.getFileS3('skb', this.state.fileSKB.filename);
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  };

  renderSKBAttachment = () => {
    if (this.state.skb === "Y") {
      return (
        <a
          href="#"
          onClick={this.handleRedirect.bind(this)}
          target="blank"
          rel="noopener noreferrer"
        >
          {this.state.fileSKB.filename}
        </a>
      );
    }
  };

  renderSKBNumber = () => {
    if (this.state.skb === "Y") {
      return (
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
            SKB Number
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              disabled
              autoComplete="off"
              className="form-control"
              id="inputEmail3"
              name="skbNumber"
              placeholder=""
              onChange={this.handleChangeInput.bind(this)}
              value={this.state.skbNumber}
            />
          </div>
        </div>
      );
    }
  };

  customerInfo = () => {
    // console.log(this.state.productList);
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="customerName"
                placeholder=""
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.customerName}
              />
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP Name
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="header_npwp_name"
                placeholder=""
                value={this.state.header_npwp_name}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Npwp Address
            </label>
            <div className="col-sm-9">
              <textarea
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="headerNpwpAddress"
                placeholder=""
                value={this.state.header_npwp_address}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP / NIK
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="header_npwp"
                placeholder=""
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.header_npwp}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showError()}
                    {this.showSuccess()}
                    <form className="form-horizontal">
                      <h5>General Info</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Claim Number
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Skp"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.claimnumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Skp Number
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Skp"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.skpnumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Number
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="programNumber"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programNumber}
                              />
                            </div>
                          </div>

                          {/* <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Beban</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="beban" placeholder="Principal" onChange={this.handleChangeInput.bind(this)} value={this.state.beban} />
                                                        </div>
                                                    </div> */}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Principal
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.principalName}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Reff Number / SKP
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.refNumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Type
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="programType"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Budget Type
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="budgetType"
                                placeholder="budgetType"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.budgetType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Descriptions
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="description"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.description}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Submitted Date
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.submitteddate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Start Date
                            </label>
                            <div className="col-sm-3">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.startDate}
                              />
                            </div>
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-2 col-form-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-3">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.endDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Claim Exp Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.claimExpDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.program_budget.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              />
                            </div>
                          </div>
                          {/* <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Assign Budget</label>
                                                        <div className="col-sm-8">
                                                            <input type="number" disabled autoComplete="off" className="form-control" id="inputEmail3" placeholder="Budget" name="budget" onChange={ this.handleChangeInput.bind(this) } value={ this.state.assign_budget } />
                                                        </div>
                                                    </div> */}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Sales Target
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Sales Target"
                                name="salesTarget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.sales_target.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.pphType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPh Rate (%)
                            </label>
                            <div className="col-sm-4">
                              <input
                                disabled
                                type="number"
                                max="100"
                                min="0"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphRate"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                          {/* <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="customerName"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.customerName}
                              />
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-12">
                          <h5>Customer Info</h5>
                          {this.customerInfo()}
                        </div>
                      </div>
                      <hr />
                      <h5>Claim Info</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Payment Method
                            </label>
                            <div className="col-sm-9 mt-2">
                              <div className="form-check form-check-inline">
                                <input
                                  disabled
                                  className="form-check-input"
                                  type="radio"
                                  checked={
                                    this.state.paymentMethod === "INV"
                                      ? true
                                      : false
                                  }
                                  name="potongTagihan"
                                  id="inlineRadio1"
                                  value="INV"
                                  onChange={this.handleChangeInput.bind(this)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio1"
                                >
                                  Deduct to receivable
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  disabled
                                  className="form-check-input"
                                  type="radio"
                                  checked={
                                    this.state.paymentMethod === "TRF"
                                      ? true
                                      : false
                                  }
                                  name="potongTagihan"
                                  id="inlineRadio2"
                                  value="TRF"
                                  onChange={this.handleChangeInput.bind(this)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio2"
                                >
                                  Transfer
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  disabled
                                  className="form-check-input"
                                  type="radio"
                                  checked={
                                    this.state.paymentMethod === "DEP"
                                      ? true
                                      : false
                                  }
                                  name="potongTagihan"
                                  id="inlineRadio2"
                                  value="DEP"
                                  onChange={this.handleChangeInput.bind(this)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio2"
                                >
                                  Deposit
                                </label>
                              </div>
                            </div>
                          </div>
                          {this.renderNorek()}
                          {/* <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              NPWP / NIK
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="npwp"
                                placeholder="NPWP"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.npwp}
                              />
                            </div>
                          </div> */}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-9">
                              {this.renderLovPPh()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Rate <small>(%)</small>
                            </label>
                            <div className="col-sm-3">
                              <input
                                disabled
                                type="number"
                                autoComplete="off"
                                max="100"
                                min="0"
                                className="form-control"
                                id="inputEmail3"
                                name="pphRate"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              DPP
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="dpp"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.dpp}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPN
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ppn"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ppn}
                              />
                            </div>
                          </div>
                          {this.renderTax()}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              SKB
                            </label>
                            <div className="col-sm-1 mt-2">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  disabled
                                  type="checkbox"
                                  checked={
                                    this.state.skb === "Y" ? true : false
                                  }
                                  name="skb"
                                  id="inlineRadio1"
                                  value="Y"
                                />
                              </div>
                            </div>
                            {this.renderSKBAttachment()}
                          </div>
                          {this.renderSKBNumber()}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPh
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="pph"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pph}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Total Claim
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="totalAmount"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.totalAmount}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer Receipt No.
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="kwitansi"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.kwitansi}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {this.renderTableInvoice()}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-12">
                          <h5>Products</h5>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Product Description
                          </label>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-2 col-form-label"
                          >
                            Product Reff
                          </label>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-2 col-form-label"
                          >
                            Product Budget
                          </label>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-2 col-form-label"
                          >
                            Actual
                          </label>
                          {this.renderProduct()}
                        </div>
                      </div>
                      <hr />
                      <h5>E-bupot</h5>
                      <div className="row mb-3">
                        {/* <div className="col-md-6">
                          {this.state.ebupot_filename}
                        </div> */}

                        <div className="col-md-6">
                          <i className="fa fa-file-pdf text-danger" />
                          &nbsp;{" "}
                          <a style={{ color: "blue" }} onClick={() => this.downloadAttachment(this.state.fileBupot)}>
                            {this.state.ebupot_filename}
                          </a>
                          {/* <Link
                            to={{ pathname: this.state.ebupot_path }}
                            target="_blank"
                          >
                            {this.state.ebupot_filename}
                          </Link> */}
                          {/* <Link
                            to={{ pathname: this.state.ebupot_path }}
                            target="_blank"
                          >
                            {this.state.ebupot_filename}
                          </Link> */}
                        </div>
                      </div>
                      <hr />
                      <h5>Attachments</h5>
                      <div className="row mb-3">
                        <div className="col-md-6">{this.renderDocument()}</div>
                        <div className="col-md-6">{this.renderLink()}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          {
                            this.props.history.action === "POP" ?
                              ''
                              :
                              <button
                                type="button"
                                className="btn btn-warning"
                                onClick={() => {
                                  this.props.history.push("/admin/claim/summary");
                                }}
                              >
                                <i className="fas fa-arrow-left"></i> Back
                              </button>
                          }
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Detail;
